import { Item } from '../Card';
import React, { useContext } from 'react';
import { TrackingContext } from '../../TrackingContext';
import shared from '../WeddingPageCard/eventList.scss';
import { ItemProps } from './common';
import EventList from '../WeddingPageCard/EventList';

interface Props extends ItemProps {
  onEventUpdate?: () => void;
}

const EventGroup: React.FC<Props> = ({
  className,
  dragProps,
  iframeRef,
  hideTitle = false,
  onEventUpdate = () => {},
}) => {
  const { loadingBaseProps, baseProps } = useContext(TrackingContext);

  return (
    <Item className={`${className}`} showGrabber={true} {...dragProps}>
      <div className={shared.fullWidth}>
        {!loadingBaseProps ? (
          <EventList
            analyticsProps={baseProps}
            iframeRef={iframeRef}
            hideTitle={hideTitle}
            onEventUpdate={onEventUpdate}
          />
        ) : null}
      </div>
    </Item>
  );
};
export default EventGroup;
